
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ItemsActionName } from '@/definitions/app/item.actions.name';
import { ItemViewModel } from '@/definitions/view-models';
import { User } from '@/api';
import { ModelAclResult } from '@/store/acl/types';
import { configModule } from '@/store/config';
import { actionHandler } from '@/store/data/ActionHandler';
import { actionsModule } from '@/store/data/ActionsModule';
import { MultisidebarItem } from '@/store/multisidebar/types';
import { Action } from '@/uikit';
import NForm from '@/uikit/forms/NForm.vue';
import NTabs from '@/uikit/tabs/NTabs.vue';
import MultisidebarHeader from '@/components/multisidebar/MultisidebarHeader.vue';
import MultisidebarSaveActions from '@/components/multisidebar/MultisidebarSaveActions.vue';
import UserFaces from '@/pages/users/form/UserFaces.vue';
import UserForm from '@/pages/users/form/UserForm.vue';

const Tabs = {
  Information: 'information',
  Photos: 'photos'
};

@Options({
  name: 'UsersSidebar',
  components: {
    MultisidebarHeader,
    MultisidebarSaveActions,
    NForm,
    NTabs,
    UserFaces,
    UserForm
  }
})
export default class UsersSidebar extends Vue {
  @Prop({ type: Object, required: true })
  readonly sidebarItem!: MultisidebarItem<ItemViewModel<User>>;

  @Prop({ type: Object, required: true })
  readonly modelAcl!: ModelAclResult;

  activeTab = Tabs.Information;

  get model() {
    return this.sidebarItem.model;
  }

  get item() {
    return this.sidebarItem.model.item;
  }

  get isNew() {
    return this.sidebarItem.model.isNew;
  }

  get tabItems() {
    const facesEnabled = configModule.getBoolean('objects.faces.enabled', false);
    const infoTab = {
      name: Tabs.Information,
      label: this.$t(`common.${Tabs.Information}`, 'f')
    };
    const photoTab = {
      name: Tabs.Photos,
      label: this.$t(`common.${Tabs.Photos}`, 'f')
    };

    return (this.isAdUser || !facesEnabled) ? [infoTab] : [infoTab, photoTab];
  }

  get isAdUser() {
    return configModule.config.services.ffsecurity.active_directory && this.item?.ad_user;
  }

  get headerActions(): Action[] {
    return actionsModule
      .getItemActions(this.modelAcl, {
        hasChanges: this.sidebarItem.model?.hasChanges,
        hasActive: true,
        currentActive: this.item?.active,
        hasDelete: !this.isAdUser
      })
      .map(actionsModule.computeActionByName);
  }

  get disableActions() {
    const id = this.model.item?.id || -1;
    return id < 0;
  }

  actionHandler(actionName: ItemsActionName, payload: any) {
    actionHandler.run(actionName, payload);
  }

  saveHandler() {
    this.sidebarItem.model.save();
  }
}
